import { render } from "./StockTable.vue?vue&type=template&id=2eb8bc09&scoped=true"
import script from "./StockTable.vue?vue&type=script&lang=js"
export * from "./StockTable.vue?vue&type=script&lang=js"

import "./StockTable.vue?vue&type=style&index=0&id=2eb8bc09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb8bc09"]])

export default __exports__